import React, { FunctionComponent } from 'react';
import Modal from '@justgiving/modal';
import urlJoin from 'url-join';
import '@justgiving/modal/src/Modal.scss';
import generateHash from '../../utils/generateHash';
import QRWrapper from './QRWrapper';
import QRTips from './QRTips';
import styles from './QRModal.scss';
import { useTranslation } from 'react-i18next';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';

type QRModalProps = {
  ownerName?: string;
};

export const QRModal: FunctionComponent<QRModalProps> = ({ ownerName }) => {
  const { pageUrl } = useNotNullableContext(PageMetaContext);
  const shareUrl = urlJoin(
    pageUrl,
    `?utm_source=offline&utm_medium=qrcode&utm_term=${generateHash()}`,
  );
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Modal
      isOpen
      onRequestClose={() => (window.location.href = pageUrl)}
      portalClassName={styles['qr-modal-portal']}
    >
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-8 offset-md-2 jg-space-mbsm">
            <h2 className="jg-text--center">{t('QRView.title')}</h2>
            <p className="jg-text--center">{t('QRView.description')}</p>
          </div>

          <div
            className="col-xs-8 offset-xs-2 col-md-6 offset-md-3"
            data-qa="qr-wrapper"
          >
            <QRWrapper url={shareUrl} name={ownerName} />
          </div>

          <QRTips />
        </div>
      </div>
    </Modal>
  );
};

export default QRModal;
